module.exports = __webpack_public_path__ + "static/media/go-top.48d7d8d3.svg";